class WrapperService {
    onScrollToBottom?: (() => void) | null

    setOnScrollToBottom = (callback: (() => void) | null) => {
        this.onScrollToBottom = callback
    }
}

export const wrapperService = new WrapperService()